<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 25 24" fill="none">
    <path d="M11.6667 6.16669H13.3333M9.16667 20.3334H15.8333C16.7538 20.3334 17.5 19.5872 17.5 18.6667V5.33335C17.5 4.41288 16.7538 3.66669 15.8333 3.66669H9.16667C8.24619 3.66669 7.5 4.41288 7.5 5.33335V18.6667C7.5 19.5872 8.24619 20.3334 9.16667 20.3334Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'MobileIcon',
  props: {
    width: {
      type: Number,
      default: 24
    },
    height: {
      type: Number,
      default: 24
    }
  }
}
</script>

<style scoped></style>